import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

const SIM_CARDS_STATS_FIELDS = {
    SIM_PROVIDER: {
        key: 'simProvider',
        type: FIELD_TYPES.TEXT
    },
    ACTIVE_SIM_COUNT: {
        key: 'activeSimCount',
        type: FIELD_TYPES.NUMBER
    },
    INACTIVE_SIM_COUNT: {
        key: 'inactiveSimCount',
        type: FIELD_TYPES.NUMBER
    },
    TOTAL_SIM_COUNT: {
        key: 'totalSimCount',
        type: FIELD_TYPES.NUMBER
    },
    OFFERS_BREAKDOWN: {
        key: 'offersBreakdown',
        type: FIELD_TYPES.OBJECT
    }
};

export default SIM_CARDS_STATS_FIELDS;